import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DragScrollDirective } from '@df/ui/common/drag-scroll.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { CMS_COMPONENT_CATEGORY_QUICK_LINKS_CONFIG } from './cms-component-category-quick-links.config';
import { NCmsComponentCategoryQuickLinks } from './cms-component-category-quick-links.interface';

@Component({
    selector: 'cms-component-category-quick-links',
    templateUrl: './cms-component-category-quick-links.component.html',
    styleUrl: './cms-component-category-quick-links.component.scss',
    standalone: true,
    imports: [
        DragScrollDirective,
        HrefComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsComponentCategoryQuickLinksComponent>(CMS_COMPONENT_CATEGORY_QUICK_LINKS_CONFIG)
export class CmsComponentCategoryQuickLinksComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsComponentCategoryQuickLinks.IData;
}
